import React from 'react'
import { gsColors } from '../../styles/Variables'
import { Text, Header1 } from '../../styles/Components'
import { useAuthContext } from './reducer'
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import { mq } from '../../helpers'
import styled from '@emotion/styled'

const Wrapper = styled.div`
  text-align: center;

  .header {
    margin: 90px 0 0;
    text-align: center;

    /* Figma auth headline is 48px (global Header1 is 54px); scope the override here.
       Desktop-only so mobile keeps Header1's 28px. */
    ${mq('min', '768px')} {
      font-size: 48px;
    }
  }

  .sign-in-subheader {
    text-align: center;
  }
`

/*
 * AuthHeaders — headlines + subtext for the OTP-only auth flow.
 *
 * Three modes, all driven by `otpChannel` + `showOTPInput` (+ account-selection):
 *   - Entry:   "Welcome to Glamsquad" + "Enter your US mobile number" (phone) / "Enter your email address" (email)
 *   - OTP:     "Enter 6-digit code" + "We sent a code to {destination}"
 *   - Signup:  "Let's set up your account" + "This information is required to book an appointment"
 */
export const AuthHeaders = ({
  formModeSignUp
}) => {
  const { state } = useAuthContext()
  const { otpChannel, showOTPInput } = state
  const isEmail = otpChannel === 'email'

  // destination the code was sent to, for the OTP subtext
  const destination = isEmail
    ? state.email.value
    : formatPhoneNumberIntl(state.phone.value)

  const hasAccessTokens = state.accessTokens && state.accessTokens.length > 0
  const isSignUpMode = formModeSignUp && !showOTPInput
  const isEntryMode = !formModeSignUp && !showOTPInput
  const isOTPInputMode = showOTPInput && !hasAccessTokens

  return (
    <Wrapper>
      {/* select-an-account header (multiple tokens for the same identifier) */}
      {hasAccessTokens && (
        <>
          <Header1 className='header'>
            Select an account
          </Header1>

          <Text margin='12px 0 45px 0'>We found more than one account with the same {state.otpChannel === 'email' ? 'email address' : 'phone number'}.</Text>
        </>
      )}

      {/* entry screen header */}
      {isEntryMode && !hasAccessTokens && (
        <>
          <Header1 className='header'>
            Welcome to Glamsquad
          </Header1>
          <div className='sign-in-subheader'>
            <Text margin='12px 0 0 0'>
              {isEmail ? 'Enter your email address' : 'Enter your US mobile number'}
            </Text>
          </div>
        </>
      )}

      {/* create-account header */}
      {isSignUpMode && !hasAccessTokens && (
        <>
          <Header1 className='header'>
            Let&rsquo;s set up your account
          </Header1>
          <Text margin='12px 0 0 0'>
            This information is required to book an appointment
          </Text>
        </>
      )}

      {/* OTP input header */}
      {isOTPInputMode && (
        <div style={{ marginTop: 30 }}>
          <Header1 className='header'>
            Enter 6-digit code
          </Header1>

          <Text
            variant="small"
            color={gsColors.black}
            style={{ textAlign: 'center', marginTop: 12 }}
            weight={400}
          >
            We sent a code to {destination}
          </Text>
        </div>
      )}
    </Wrapper>
  )
}
